<template>
    <SideBar v-model:mini="mini"/>

    <AppBar :mini="mini"/>

    <main
        class="pb-5 pr-8 h-full flex-grow overflow-aut transition-spacing duration-150 ease-in-out overscroll-none"
        :class="mini ? 'pl-31' : 'pl-76'"
    >
        <div class="relative flex flex-col h-full">
            <router-view/>
        </div>
    </main>
</template>

<script>
import SideBar from '@/components/navigations/SideBar'
import AppBar from '@/components/navigations/AppBar'

import { mapState } from 'vuex'

export default {
    name: 'MainLayout',
    components: { SideBar, AppBar },
    data: () => ({
        mini: false,
    }),
}
</script>
